//
// Action types
//

export const REGISTER_NEW_MAP_ELEMENT = "REGISTER_NEW_MAP_ELEMENT";

//
// Action creators
//

export function registerNewMapElement(mapKey) {
  return {
    type: REGISTER_NEW_MAP_ELEMENT,
    mapKey
  };
}

function registerNewMapElementHandler(state) {
  const lastMapElement = state.lastMapElement + 1;
  return { ...state, lastMapElement };
}

//
// Reducer and handlers
//

export function reduceMapElements(state, action) {
  switch (action && action.type) {
    case REGISTER_NEW_MAP_ELEMENT:
      return registerNewMapElementHandler(state);

    default:
      return state || { lastMapElement: 0 };
  }
}
